"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  margin: 0 16px;\n  overflow: hidden;\n  cursor: pointer;\n  align-items: center;\n\n  .label {\n    font-family: ", ";\n    color: ", ";\n    font-size: 14px;\n    margin: 0 14px 0 0;\n  }\n\n  .sort {\n    font-size: 22px;\n\n    &::before {\n      color: ", ";\n    }\n\n    &.INACTIVE::before {\n      color: ", "35;\n    }\n  }\n"], ["\n  display: flex;\n  flex: 1;\n  margin: 0 16px;\n  overflow: hidden;\n  cursor: pointer;\n  align-items: center;\n\n  .label {\n    font-family: ", ";\n    color: ", ";\n    font-size: 14px;\n    margin: 0 14px 0 0;\n  }\n\n  .sort {\n    font-size: 22px;\n\n    &::before {\n      color: ", ";\n    }\n\n    &.INACTIVE::before {\n      color: ", "35;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map